import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './locales/en/translations.json';
import deTranslations from './locales/de/translations.json';
import itTranslations from './locales/it/translations.json';
import frTranslations from './locales/fr/translations.json';
import esTranslations from './locales/es/translations.json';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: window.localStorage.getItem('ly-ui-language') ? window.localStorage.getItem('ly-ui-language') : 'en',
  resources: {
    en: { translations: enTranslations },
    de: { translations: deTranslations },
    it: { translations: itTranslations },
    fr: { translations: frTranslations },
    es: { translations: esTranslations }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'de', 'it', 'fr', 'es'];

export default i18n;
